import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.logo = document.querySelector('.c-logo')
    this.menuToggle = document.querySelector('.c-menu-toggle')

    this.h1 = this.el.querySelector('.c-heading')
    this.content = this.el.querySelector('.c-text.-c2')
    this.button = this.el.querySelector('.c-button-icon')
    this.mask = this.el.querySelector('.c-home-header_mask')
    this.maskImg = this.mask.querySelector('img')
    this.maskBackground = this.mask.querySelector('.c-home-header_mask_background')
    this.videoBg = this.el.querySelector('.c-home-header_backgrounds video')

    this.state = null

    this.tlShowLogo = this.getTLShowLogo()
    this.tlShowTitle = this.getTLShowTitle()

    this.events = { click: { scroll: 'scrollToNext' } }
  }

  startTimer() {
    setTimeout(() => {
      if (this.state === null) {
        this.call(
          'scrollTo',
          '.c-home-header_scroller.-title',
          'Scroll'
        )
      }
    }, 3000)
  }

  switchHomeHeader(e) {
    if (e.way === 'enter') {
      if (this.state !== null) {
        this.state = 1
        this.tlShowLogo.restart()
        this.tlShowLogo.play()
      }
    }
    else {
      this.state = 2
      this.tlShowTitle.restart()
      this.tlShowTitle.play()
    }
  }

  getTLShowLogo() {
    const tl = gsap.timeline({ paused: true })

    tl.call(
      () => {
        this.h1.classList.remove('is-inview')
        this.content.classList.remove('is-inview')
        this.videoBg.play()
      },
      null,
      0
    )

    tl.to(
      this.maskBackground,
      {
        opacity: 1,
        duration: 0.2,
        ease: 'none'
      },
      0.2
    )
    tl.to(
      this.maskImg,
      {
        y: '0',
        scale: 1,
        opacity: 1,
        duration: 0.4,
        ease: 'power4.out'
      },
      0.2
    )

    return tl
  }

  getTLShowTitle() {
    const tl = gsap.timeline({ paused: true })

    tl.to(
      this.maskImg,
      {
        y: '-50lvh',
        opacity: 0,
        duration: 0.4,
        ease: 'power4.out'
      },
      0
    )
    tl.to(
      this.maskBackground,
      {
        opacity: 0,
        duration: 0.2,
        ease: 'none'
      },
      0.2
    )

    tl.call(
      () => {
        this.h1.classList.add('is-inview')
        this.content.classList.add('is-inview')
        this.logo.classList.add('-visible')
        this.menuToggle.classList.add('-visible')
        this.videoBg.pause()
      },
      null,
      0.3
    )

    return tl
  }

  scrollToNext() {
    if (this.state === null || this.state === 1) {
      this.call(
        'scrollTo',
        '.c-home-header_scroller.-title',
        'Scroll'
      )
    }
    if (this.state === 2) {
      this.call(
        'scrollTo',
        '.c-home-header_scroller.-content',
        'Scroll'
      )
    }
  }
}
